import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'ramda';
import styled from 'styled-components';
import { Button } from '@prezi/bento';
import { viewLinkActions } from '../../../../store/actions/viewLinkActions';
import { InnerScreenGrid, RowGrid } from '../../../atoms/dumb';
import { Header } from '../../../molecules/dumb';
import { FooterSimple } from '../../../organisms/smart';
import analyticsControlContextSelector from '../analyticsControlContextSelector';
import LinkNameInput from './LinkNameInput';
import { ToggleAnalytics, ToggleRequireEmail } from './analyticsToggleButtons';
import { localI18n } from '../../../../i18n';
const uxCopy = {
  header: localI18n._("Create New Link"),
  saveButton: localI18n._("Save Link")
};
const SaveButtonWrapper = styled.div.withConfig({
  displayName: "CreateLink__SaveButtonWrapper",
  componentId: "sc-1f4s0bc-0"
})(["display:flex;justify-content:flex-end;padding:8px 0;"]);
const CreateLink = ({
  goBack
}) => {
  const dispatch = useDispatch();
  const analyticsControlContext = useSelector(analyticsControlContextSelector);
  const [name, setName] = React.useState('');
  const [visibleOnAnalytics, setVisibleOnAnalytics] = React.useState(!analyticsControlContext.disabled);
  const [viewerIdentification, setViewerIdentification] = React.useState(false);
  React.useEffect(() => {
    if (!visibleOnAnalytics) {
      setViewerIdentification(false);
    }
  }, [visibleOnAnalytics]);
  return React.createElement(InnerScreenGrid, null, React.createElement(Header, {
    onBack: goBack
  }, uxCopy.header), React.createElement(RowGrid, null, React.createElement(LinkNameInput, {
    value: name,
    onChange: setName
  }), React.createElement(ToggleAnalytics, {
    handleOnChange: setVisibleOnAnalytics,
    checked: visibleOnAnalytics,
    controlContext: analyticsControlContext
  }), React.createElement(ToggleRequireEmail, {
    handleOnChange: setViewerIdentification,
    checked: viewerIdentification,
    controlContext: analyticsControlContext.disabled ? analyticsControlContext : {
      disabled: !visibleOnAnalytics
    }
  }), React.createElement(SaveButtonWrapper, null, React.createElement(Button, {
    variant: "primary",
    disabled: isEmpty(name),
    onClick: () => {
      dispatch(viewLinkActions.createViewlink({
        name,
        visibleOnAnalytics,
        viewerIdentification
      }));
      goBack();
    }
  }, uxCopy.saveButton))), React.createElement(FooterSimple, null));
};
export default CreateLink;